<template>
  <v-flex>
    <v-card>
      <v-card-title primary-title>
        <v-layout row>
          <v-flex grow pa-1>
            <h1 class="headline">Partner payments</h1>
          </v-flex>
          <v-flex shrink pa-1>
            <v-btn dark color="primary" @click="toggleAddNewPayment">
              {{ btnAddNewPaymentTitle }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>

      <AddPayment v-if="showAddNewPayment"></AddPayment>

      <v-card-text v-else>
        <template>
          <div>
            <v-text-field
              v-model="paymentSearch"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-data-table
              :items="payments || []"
              :headers="paymentsTableHeaders"
              :expand="expand"
              item-key="id"
              :search="paymentSearch"
              :pagination.sync="pagination"
            >
              <template v-slot:items="props">
                <tr @click="props.expanded = !props.expanded">
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.ts_utc | formatDate }}</td>
                  <td>{{ props.item.currency_name }}</td>
                  <td>
                    {{
                      $options.filters.toETHFormat(props.item.value_wei_str)
                        | roundMarketsFractionalAccountValue
                    }}
                  </td>
                </tr>
              </template>
              <template v-slot:expand="props">
                <v-card flat>
                  <v-card-text> Payment ID: {{ props.item.id }} </v-card-text>
                  <v-card-text>
                    Partner ID: {{ props.item.fe_invites_id }}
                  </v-card-text>
                  <v-card-text>
                    Transaction ID: {{ props.item.tx_id }}
                  </v-card-text>
                  <v-card-text>
                    To address: {{ props.item.to_addr }}
                  </v-card-text>
                  <v-card-text>
                    Value (WEI): {{ props.item.value_wei_str }} ({{
                      $options.filters.toETHFormat(props.item.value_wei_str)
                        | roundMarketsFractionalAccountValue
                    }}
                    {{ props.item.currency_name }})
                  </v-card-text>
                  <v-btn dark color="primary" @click="expandUserDeposits">
                    {{ btnTitle }}
                  </v-btn>
                  <v-btn dark color="primary" @click="expandEditPayment">
                    {{ btnTitlePayment }}
                  </v-btn>

                  <EditPayment
                    v-if="showEditPayment"
                    :key="props.item.id"
                    :payment-id="props.item.id"
                  ></EditPayment>

                  <UserDeposits
                    v-if="showUserDeposits"
                    :key="props.item.id"
                    :payment-id="props.item.id"
                    :payment-currency="props.item.currency_name"
                  ></UserDeposits>
                </v-card>
              </template>
            </v-data-table>
          </div>
        </template>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";
import UserDeposits from "./UserDeposits";
import AddPayment from "./AddPayment";
import VButton from "../global/Button";
import EditPayment from "./EditPayment";

export default {
  name: "PartnerPayments",
  components: {
    VButton,
    UserDeposits,
    AddPayment,
    EditPayment
  },
  data: function() {
    return {
      base_url: window.location.origin,
      showUserDeposits: false,
      showEditPayment: false,
      payments: null,
      paymentSearch: "",
      expand: false,
      showAddNewPayment: false,
      btnTitle: "Show user deposits",
      btnTitlePayment: "Edit payment",
      btnAddNewPaymentTitle: "Add new payment",
      paymentsTableHeaders: [
        { text: "Name", value: "name" },
        {
          text: `Date (${moment()
            .tz(moment.tz.guess())
            .format("z")})`,
          value: "ts_utc"
        },
        { text: "Currency", value: "currency_name" },
        { text: "Value", value: "value_wei_str" }
      ],
      pagination: {
        descending: true,
        sortBy: "ts_utc"
      }
    };
  },

  mounted: async function() {
    axios.get("/api/v1/admin/payments").then(res => {
      this.payments = res.data;
    });
  },

  methods: {
    expandUserDeposits: function() {
      this.showUserDeposits = !this.showUserDeposits;
      if (this.showUserDeposits) {
        this.showEditPayment = false;
        this.btnTitlePayment = "Edit payment";
      }
      this.btnTitle = this.showUserDeposits
        ? "Hide user deposits"
        : "Show user deposits";
    },
    expandEditPayment: function() {
      this.showEditPayment = !this.showEditPayment;
      if (this.showEditPayment) {
        this.showUserDeposits = false;
        this.btnTitle = "Show user deposits";
      }
      this.btnTitlePayment = this.showEditPayment
        ? "Cancel edit payment"
        : "Edit payment";
    },
    toggleAddNewPayment: function() {
      this.showAddNewPayment = !this.showAddNewPayment;
      this.btnAddNewPaymentTitle = this.showAddNewPayment
        ? "Cancel payment"
        : "Add new payment";
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/admin/PartnerPayments.vue